import React, { useState, useEffect } from "react";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, navigate } from "gatsby";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import womanHairIcon from "common/assets/image/woman-hair.svg";
import glowingSkinIcon from "common/assets/image/glowing-skin.svg";

import Container from "common/components/UI/Container";
import SectionWrapper, { CategorySwitcher } from "./heroarea.style";
import Fade from "react-reveal/Fade";
import Flip from "react-reveal/Flip";

// Install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const highlightHeading = (text) => {
  if (!text) return "";
  let formatted = text;

  // Highlight common keywords for radiance hair studio
  formatted = formatted.replace(
    /(Hair Patch\s*(?:&|&amp;|and)\s*Wig\s*Solutions?['s]*|Hair Patch|Wig Solutions?['s]*|Hair Wigs?)/gi,
    '<span class="highlight">$1</span>',
  );

  // Add line break before starting/pricing text to force 2 lines
  formatted = formatted.replace(
    /(Starting\s*@|Start\s*Only\s*@)/gi,
    "<br />$1",
  );

  // Highlight prices (e.g. ₹6999, Rs. 6999, etc.)
  formatted = formatted.replace(
    /(₹\d+|Rs\.\s*\d+)/gi,
    '<span class="highlight-price">$1</span>',
  );

  return formatted;
};

function Heroarea({ activeTab = "hair", setActiveTab }) {
  const [bannerData, setBannerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isHair = activeTab === "hair";

  const handleCategorySwitch = (cat) => {
    if (setActiveTab) {
      setActiveTab(cat);
    } else if (cat === "skin") {
      navigate("/skin");
    } else {
      if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  useEffect(() => {
    const fetchBannerData = async () => {
      try {
        const response = await fetch(
          `https://radianceadmin.manageprojects.in/api/homebanner`,
        );
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();

        if (data.success && Array.isArray(data.data)) {
          // Ensure images field contains full URLs
          const formattedData = data.data.map((banner) => ({
            ...banner,
            images: Array.isArray(banner.images)
              ? banner.images.map((img) => img)
              : [banner.images],
          }));
          console.log(formattedData, "formattedData");
          setBannerData(formattedData);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    };

    fetchBannerData();
  }, []);

  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <SectionWrapper className="web-height" id="hero__Area">
        <CategorySwitcher>
          <div className="category-pill-wrapper">
            <Link
              to="/"
              className="cat-tab-btn hair-btn active"
            >
              <span className="category-tab-icon hair-icon-badge" aria-hidden="true">
                <img src={womanHairIcon} alt="Hair Solutions" width="16" height="16" />
              </span>
              <span>Hair Solutions</span>
            </Link>
            <Link
              to="/skin-treatments.php"
              className="cat-tab-btn skin-btn"
            >
              <span className="category-tab-icon skin-icon-badge" aria-hidden="true">
                <img src={glowingSkinIcon} alt="Skin Treatments" width="16" height="16" />
              </span>
              <span>Skin Treatments</span>
            </Link>
          </div>
        </CategorySwitcher>

        <Container className="fullWidthContainer heroRowMain2">
          <div className="fixedText">
            <Fade>
              <span className="eyebrow">Premium Hair Solutions</span>
              <Flip top>
                {loading ? (
                  <Skeleton width={700} height={40} />
                ) : (
                  <h1
                    dangerouslySetInnerHTML={{
                      __html: highlightHeading(
                        bannerData[0]?.banner_heading ||
                        "Hair Patch & Wig Solution's Start Only@ ₹6999",
                      ),
                    }}
                  />
                )}
              </Flip>
              <div className="divider" />
              <div className="action__btns">
                <div className="linkbtn">
                  {loading ? (
                    <Skeleton width={180} height={40} />
                  ) : (
                    <Link
                      to={bannerData[0]?.test_link || "/take-the-hair-test.php"}
                      className="btn btn-default"
                    >
                      {bannerData[0]?.test_text || "Take The Hair Test"}
                    </Link>
                  )}
                </div>
                <div className="linkbtn">
                  {loading ? (
                    <Skeleton width={180} height={40} />
                  ) : (
                    <Link
                      to={bannerData[0]?.expert_link || "/appointment.php"}
                      className="btn btn-default black"
                    >
                      {bannerData[0]?.expert_text || "Book Free Consultation"}
                    </Link>
                  )}
                </div>
              </div>
            </Fade>
          </div>
          {/* <Swiper
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{ delay: 4000 }}
            loop={true}
            navigation={false}
          >
            <SwiperSlide> */}
          {loading ? (
            <Skeleton width="100%" height={680} />
          ) : (
            <div
              className="hero_slider"
              style={{
                position: "relative",
                overflow: "hidden",
                width: "100%",
              }}
            >
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 0,
                }}
              >
                <source src="/radiancebanner.mp4" type="video/mp4" />
              </video>
              <div className="slide_overlay"></div>
            </div>
          )}
          {/* </SwiperSlide>
            {bannerData.length > 0 && bannerData[0].images.length > 0 &&
              bannerData[0].images.map((image, index) => (
                <SwiperSlide key={index}>
                  <>
                    {loading ? (
                      <Skeleton width="100%" height={582} />
                    ) : (
                      <div
                        className="hero_slider"
                        style={{
                          backgroundImage: `url(${image})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                        }}
                        role="img"
                        aria-label={bannerData[0].alt_text || `Hero banner image ${index + 1}`}
                      >
                        <div className="slide_overlay"></div>
                      </div>
                    )}
                  </>
                </SwiperSlide>
              ))
            }
          </Swiper> */}
        </Container>
      </SectionWrapper>
    </>
  );
}

export default Heroarea;
